import SideBar from "components/our-services/SideBar";
import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Tab } from "react-bootstrap";

const AdvisoryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_4.title}</h2>
      <Tab.Container id="advisory-services" defaultActiveKey="first">
        <Row>
          <Row>
            <Col>
              <p>{lang.services.lists.list_4.paragraph}</p>
            </Col>
            <SideBar />
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default AdvisoryPage;
